<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <button
      type="button"
      class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-all ease-in-out duration-200 focus:outline-none"
      :class="
        context.model
          ? isContributor
            ? 'bg-cw-alt'
            : 'bg-primary'
          : 'bg-gray-200'
      "
      role="switch"
      aria-checked="false"
      @click="toggleValue"
    >
      <span
        aria-hidden="true"
        class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
        :class="[context.model ? 'translate-x-5' : 'translate-x-0']"
      />
    </button>
  </div>
</template>

<script>
import { defineComponent, onMounted, computed } from 'vue'
import { useStore } from '../../../js/store/index.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import { EVENT_KEYS } from '../../../js/util/constants.js'

export default defineComponent({
  name: 'VueFormulateToggle',

  props: {
    context: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const store = useStore()
    const isContributor = computed(() => store.getters['shared/isContributor'])

    const setValue = (value) => {
      props.context.model = value
    }

    const toggleValue = () => {
      setValue(!props.context.model)
    }

    onMounted(() => {
      EventBus.$on(EVENT_KEYS.CO_VUE_FORMULATE_TOGGLE_UPDATED, (value) =>
        setValue(value),
      )
    })

    return {
      isContributor,
      toggleValue,
    }
  },
})
</script>
